export interface DocumentValidationExceptionI {
  propertyPaths: string[];
  translatedMessage: string;
}

export function isDocumentValidationException(err: DocumentValidationExceptionI[]): boolean {
  return err?.length && typeof err[0]?.translatedMessage === 'string';
}
